/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Down': {
    width: 16,
    height: 16,
    viewBox: '0 0 28 28',
    data: '<defs><path pid="0" id="svgicon_Down_a" d="M15.438 11.622h-3.833v5.6c0 1.834-1.5 3.334-3.333 3.334a3.343 3.343 0 01-3.334-3.334v-5.6H1.105c-.5 0-.833-.466-.567-.8l7.167-10c.1-.2.333-.266.567-.266.233 0 .466.066.566.266l7.167 10c.267.334-.067.8-.567.8"/></defs><use transform="rotate(-180 11.05 12.278)" xlink:href="#svgicon_Down_a"/>'
  }
})
